import { useEffect } from 'react';
import { Navbar } from '@/components/landing/Navbar';
import { HeroSection } from '@/components/landing/HeroSection';
import { PainNarrative } from '@/components/landing/PainNarrative';
import { ProductShowcase } from '@/components/landing/ProductShowcase';
import { FinalCTA } from '@/components/landing/FinalCTA';
import { Footer } from '@/components/landing/Footer';

const Index = () => {
  useEffect(() => {
    document.documentElement.style.scrollSnapType = 'y mandatory';
    return () => {
      document.documentElement.style.scrollSnapType = '';
    };
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <HeroSection />
        <PainNarrative />
        <ProductShowcase />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
